import { getAppHref, getMittcaireUrl } from "@/lib/env";
import i18n from "@/i18n";
import { MCP_GUIDE_HREFS } from "@/config/publicMcp";
import { Lang } from "@/utils/routes";
import {
  platformProductSignupHref,
  platformNavAuthLabel,
  platformSignupLabel,
  platformSignInHref,
} from "@/config/platformAccess";
import {
  getPublicNavConfig,
  getPublicFooterConfig,
  getPublicNavigationTranslations,
  type NavConfig,
  type NavItem,
  type NavSection,
  type NavSubmenu,
  type HeaderSection,
  type NavTranslate,
} from "@appcaire/shared/public-navigation";

export type {
  NavConfig,
  NavItem,
  NavSection,
  NavSubmenu,
  HeaderSection,
  NavTranslate,
};
export { getHeaderSections } from "@appcaire/shared/public-navigation";

const getPublicNavDestinations = () => ({
  mcpGuideHrefs: MCP_GUIDE_HREFS,
  productSignupHref: platformProductSignupHref(),
  navAuthLabel: platformNavAuthLabel,
  signupLabel: platformSignupLabel,
  signInHref: platformSignInHref,
  mittcaireHref: getMittcaireUrl(),
  getAppHref,
});

export const getNavConfig = (t: NavTranslate, language: Lang): NavConfig =>
  getPublicNavConfig(t, language, getPublicNavDestinations());

export const getNavTranslations = (language: Lang) =>
  getPublicNavigationTranslations(language, getPublicNavDestinations());

// Register before React renders MainNav. Mutating the i18next store during
// render emits a store event and can trigger a render loop.
for (const language of ["sv", "en"] as const) {
  i18n.addResourceBundle(
    language,
    "publicSiteNav",
    getNavTranslations(language),
    true,
    false,
  );
}

/** Use the shared, localized footer taxonomy with website-owned destinations. */
export const getFooterConfig = (t: NavTranslate, language: Lang) =>
  getPublicFooterConfig(t, language, getPublicNavDestinations());
